"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfListingsHomeResponseDto = instanceOfListingsHomeResponseDto;
exports.ListingsHomeResponseDtoFromJSON = ListingsHomeResponseDtoFromJSON;
exports.ListingsHomeResponseDtoFromJSONTyped = ListingsHomeResponseDtoFromJSONTyped;
exports.ListingsHomeResponseDtoToJSON = ListingsHomeResponseDtoToJSON;
exports.ListingsHomeResponseDtoToJSONTyped = ListingsHomeResponseDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var ListingsHomeDto_1 = require("./ListingsHomeDto");
/**
 * Check if a given object implements the ListingsHomeResponseDto interface.
 */
function instanceOfListingsHomeResponseDto(value) {
    if (!('listings' in value) || value['listings'] === undefined)
        return false;
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    return true;
}
function ListingsHomeResponseDtoFromJSON(json) {
    return ListingsHomeResponseDtoFromJSONTyped(json, false);
}
function ListingsHomeResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'listings': (json['listings'].map(ListingsHomeDto_1.ListingsHomeDtoFromJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function ListingsHomeResponseDtoToJSON(json) {
    return ListingsHomeResponseDtoToJSONTyped(json, false);
}
function ListingsHomeResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'listings': (value['listings'].map(ListingsHomeDto_1.ListingsHomeDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
